module.exports = __webpack_public_path__ + "img/Mask Group3.ab5347b9.png";